import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import {
  AccordionDetails,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Link,
  Radio,
  RadioGroup,
  Stack,
  TextField
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { sectionNames } from 'src/components/QueryMenus/checklistQueriesData';
import { QueryMenus } from 'src/components/QueryMenus/QueryMenus';
import { SectionQueryIndication } from 'src/components/QueryMenus/sectionQueryIndication';
import { useQueryMenus } from 'src/components/QueryMenus/useQueryMenus';
import { ViewQuery } from 'src/components/QueryMenus/ViewQuery/ViewQuery';
import { sendRequest } from 'src/hooks/useFetch';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
// import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { clearMessage, setMessage } from 'src/store/Message';
import { ISIVReportAdverseEventReporting } from 'src/types/SIVReport';
import { formatInput } from 'src/util/STR';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import {
  IAdverseEventReportingMandatory,
  ISIVReportMandatory,
  ISIVReportModifiedKeys,
  ISIVReportModifiedKeysOfKeys,
  MandatoryData
} from './useSivReport';

import { setIsSaveButtonDisable } from 'src/store/sivReport';

const NOTES_MAXLENGTH = 2000;

export interface IAdverseEventReporting {
  getSivReportData: (key: ISIVReportModifiedKeysOfKeys, add: boolean) => void;
  saveDisable: boolean;
  adverseEventReportingData: ISIVReportAdverseEventReporting;
  updateAdverseEventReporting: (data: ISIVReportAdverseEventReporting) => void;
  isUpdate: boolean;
  isChange: boolean;
  setIsChange: (step: ISIVReportModifiedKeys, key: ISIVReportModifiedKeysOfKeys, val: boolean) => void;
  updateSIVReportMandatoryData: (key: keyof ISIVReportMandatory, value: MandatoryData) => void;
  mandatory: IAdverseEventReportingMandatory;
  sivReportSavedId: string;
  checkedInStartDate: any;
  isPublished: boolean;
  SignatureBreaking: () => void;
}

const AdverseEventReporting: React.FunctionComponent<IAdverseEventReporting> = ({
  getSivReportData,
  saveDisable,
  adverseEventReportingData,
  updateAdverseEventReporting,
  isUpdate,
  isChange,
  setIsChange,
  mandatory,
  updateSIVReportMandatoryData,
  sivReportSavedId,
  checkedInStartDate,
  isPublished,
  SignatureBreaking
}) => {
  const dispatch = useDispatch();
  const dispatchApp = useAppDispatch();
  const user = useUser();
  const { sivcDataUpdateSuccessMsg, sivcMendatoryInfoErrorMsg } = useFieldTranslation();
  const [recentData, setRecentData] = useState({ data: {}, mandatoryValidation: {} });

  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const { checkPermission } = usePermissionWrapper();
  const isDisable = checkPermission('update_siv_report');
  const perDisableQuery = checkPermission('view_queries_siv_report');
  const selectedRowData: any = useAppSelector(state => state.sivReport.selectedRowData);
  const saveButtonDisable: any = useAppSelector(state => state.sivReport.disableSaveButtonProps);
  const [refreshKey, setRefreshKey] = useState(0);
  const errorText = 'Required';

  useEffect(() => {
    if (adverseEventReportingData) {
      setRefreshKey(refreshKey + 1);
    }
  }, [Object.keys(adverseEventReportingData)?.length]);

  const handleAdverseEventReportingData = (e: any) => {
    dispatchApp(clearMessage());
    const val = e.target.value;
    const formattedVal = typeof val === 'string' ? formatInput(val) : val;
    const value = formattedVal;
    if (e.target.type === 'radio' && value === 'Y') {
      updateAdverseEventReporting({
        ...adverseEventReportingData,
        [e.target.name]: value
      });
      updateSIVReportMandatoryData('adverseEventReporting', { ...mandatory, [e.target.name]: false });
    } else if (e.target.type === 'radio') {
      updateAdverseEventReporting({
        ...adverseEventReportingData,
        [e.target.name]: value
      });
      updateSIVReportMandatoryData('adverseEventReporting', { ...mandatory, [e.target.name]: false });
    }
    //dispatch(setIsSaveButtonDisable(false));
    if (saveButtonDisable && e.target.type === 'radio') {
      dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, adverseEventReporting: false }));
    }
    setConfirmExitValue(dispatch, true);
  };

  const handleChange = (e: any) => {
    if (e.target.type !== 'radio') {
      const val = e.target.value;
      const formattedVal = typeof val === 'string' ? formatInput(val) : val;
      const value = formattedVal;
      setRecentData({
        data: {
          ...recentData.data,
          [e.target.name]: value
        },
        mandatoryValidation: { ...recentData.mandatoryValidation, [e.target.name]: false }
      });
    }
    if (saveButtonDisable) {
      dispatch(setIsSaveButtonDisable(false));
    }
  };

  const setValidationData = () => {
    const copyValidation = { ...mandatory };
    for (const key of Object.keys(copyValidation)) {
      if (
        adverseEventReportingData[key as keyof ISIVReportAdverseEventReporting] === 'N' &&
        !(
          adverseEventReportingData[`${key}_comm` as keyof ISIVReportAdverseEventReporting] &&
          adverseEventReportingData[`${key}_comm` as keyof ISIVReportAdverseEventReporting] !== null &&
          adverseEventReportingData[`${key}_comm` as keyof ISIVReportAdverseEventReporting] !== ''
        )
      ) {
        copyValidation[key as keyof IAdverseEventReportingMandatory] = true;
      } else {
        copyValidation[key as keyof IAdverseEventReportingMandatory] = false;
      }
    }
    updateSIVReportMandatoryData('adverseEventReporting', copyValidation);
    return copyValidation;
  };
  useEffect(() => {
    if (Object.keys(recentData.data).length) {
      updateAdverseEventReporting({
        ...adverseEventReportingData,
        ...recentData.data
      });
      updateSIVReportMandatoryData('adverseEventReporting', { ...mandatory, ...recentData.mandatoryValidation });
    }
  }, [recentData.data]);

  const updateAdverseEventReportingData = async () => {
    const validate = setValidationData();
    if (Object.values(validate).indexOf(true) !== -1) {
      return dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
    }
    const adverseEventReportingDataTemp = { ...adverseEventReportingData, ...recentData.data };
    const options = {
      site_id: selectedSite,
      study_id: studyId,
      data: {
        updated_by: user.user,
        monitoring_visit_id: selectedRowData?.id,
        siv_report: { step_two: { adverse_event_reporting: adverseEventReportingDataTemp } }
      },
      pathVariables: {
        country: selectedCountry,
        appName: process.env.REACT_APP_NAME
      }
    };
    try {
      if (isChange) {
        if (isUpdate) {
          if (
            adverseEventReportingDataTemp.siv_report_ae_reporting !== null &&
            adverseEventReportingDataTemp.siv_report_ae_reporting_comm !== null
          ) {
            await sendRequest('update_siv_report', options);
            if (isPublished) {
              SignatureBreaking();
            }
            getSivReportData('adverseEventReporting', false);
            dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
            setConfirmExitValue(dispatch, false);

            setIsChange('Step2', 'adverseEventReporting', false);
          } else {
            dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
          }
        }
        if (!isUpdate) {
          if (
            adverseEventReportingDataTemp.siv_report_ae_reporting !== null &&
            adverseEventReportingDataTemp.siv_report_ae_reporting_comm !== null
          ) {
            await sendRequest('create_siv_report', options);
            getSivReportData('adverseEventReporting', true);
            setConfirmExitValue(dispatch, false);
            setIsChange('Step2', 'adverseEventReporting', false);
            dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
          } else {
            dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
          }
        }
      } else if (!isChange && adverseEventReportingDataTemp.siv_report_ae_reporting === null) {
        dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
      } else {
        dispatchApp(setMessage({ msgDetails: 'No data modified', severity: 'info' }));
      }

      //dispatch(setIsSaveButtonDisable(true));
      dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, adverseEventReporting: true }));
    } catch (e) {
      dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
    }
  };

  /**
   * Query Menus code start
   */
  const {
    contextMenu,
    setContextMenu,
    queryKeys,
    setQueryKeys,
    checkListQueries,
    raisedQueries,
    totalFieldQueries,
    totalSectionQueries,
    fieldQueries,
    getSivReportQueries,
    report_id: reportId,
    setReport_id: setReportId,
    queryType,
    setQueryType,
    latestSecQueryRaisedBy,
    raisedSectionQueries
  } = useQueryMenus('SIV REPORT');

  useEffect(() => {
    setReportId(sivReportSavedId);
  }, [sivReportSavedId]);

  const handleContextMenu = (event: React.MouseEvent, checklistItem: keyof ISIVReportAdverseEventReporting) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null &&
        (checkPermission('view_queries_siv_report') ||
          checkPermission('view_audit_siv_report') ||
          checkPermission('raise_query_siv_report'))
        ? {
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4
          }
        : null
    );
    const sectionFieldNames: string[] = [];
    Object.keys(checkListQueries.adverse_event_reporting).forEach((obj: any) => {
      sectionFieldNames.push(checkListQueries.adverse_event_reporting[obj].report_field_name);
    });
    const newObj = {
      ...checkListQueries.adverse_event_reporting[checklistItem],
      id: sivReportSavedId,
      section_key: 'adverse_event_reporting',
      report_field_value: adverseEventReportingData[checklistItem],
      section_field_names: sectionFieldNames,
      is_all_field_queries: true
    };
    setQueryKeys(newObj);
  };

  const [openViewQuery, setOpenViewQuery] = useState(false);
  const viewNotes = (checklistItem: keyof ISIVReportAdverseEventReporting, isAllFieldQueries = false) => {
    let newObj: any = {};
    if (isAllFieldQueries) {
      const sectionFieldNames: string[] = [];
      Object.keys(checkListQueries.adverse_event_reporting).forEach((obj: any) => {
        sectionFieldNames.push(checkListQueries.adverse_event_reporting[obj].report_field_name);
      });
      newObj = {
        ...checkListQueries.adverse_event_reporting[checklistItem],
        id: sivReportSavedId,
        section_key: 'adverse_event_reporting',
        section_field_names: sectionFieldNames,
        is_all_field_queries: isAllFieldQueries
      };
    } else {
      newObj = {
        ...checkListQueries.adverse_event_reporting[checklistItem],
        id: sivReportSavedId,
        section_key: 'adverse_event_reporting',
        report_field_value: adverseEventReportingData[checklistItem],
        is_all_field_queries: isAllFieldQueries
      };
    }

    setQueryKeys(newObj);
    setOpenViewQuery(true);
    setQueryType('ALL');
  };

  /**
   * Query Menus code end
   */

  return (
    <>
      <AccordionDetails className="sq-checklist-tab">
        <Grid container className="checklist-radio-actions">
          {raisedSectionQueries.includes(sectionNames.adverse_event_reporting) &&
            sectionNames.adverse_event_reporting in latestSecQueryRaisedBy &&
            SectionQueryIndication(
              latestSecQueryRaisedBy,
              sectionNames.adverse_event_reporting,
              viewNotes,
              'siv_report_ae_reporting'
            )}
          <Grid md={12}>
            <Grid
              container
              onContextMenu={e => {
                handleContextMenu(e, 'siv_report_ae_reporting');
              }}
              style={{ cursor: 'context-menu' }}
              className="checklist-radio-actions"
            >
              <Grid md={9} className="alignCenterRow">
                Requirements for reporting AEs, SAEs, Pregnancies reviewed? (
                <Link underline="always">Link to AE, SAE CRF </Link>) <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <Stack direction="row" spacing={1} justifyContent="space-between">
                  <FormControl>
                    <RadioGroup
                      value={adverseEventReportingData.siv_report_ae_reporting}
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="siv_report_ae_reporting"
                      onChange={handleAdverseEventReportingData}
                    >
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="Y"
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="N"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Button
                    onClick={() => viewNotes('siv_report_ae_reporting')}
                    disabled={!perDisableQuery}
                    title="Query"
                    className={`grey-btn${
                      raisedQueries.includes('siv_report_ae_reporting') ||
                      raisedSectionQueries.includes(sectionNames.adverse_event_reporting)
                        ? ' danger-link'
                        : ''
                    }`}
                  >
                    <LiveHelpOutlinedIcon />
                  </Button>
                </Stack>
              </Grid>
              <Grid md={12} className="comment-section">
                <FormControl fullWidth margin="normal" className="siv-comment-input">
                  <TextField
                    name="siv_report_ae_reporting_comm"
                    key={`siv_report_ae_reporting_comm-${refreshKey}`}
                    defaultValue={adverseEventReportingData.siv_report_ae_reporting_comm || ''}
                    onBlur={handleAdverseEventReportingData}
                    error={mandatory['siv_report_ae_reporting']}
                    helperText={mandatory['siv_report_ae_reporting'] ? errorText : ''}
                    label="Notes"
                    variant="outlined"
                    inputProps={{ maxLength: NOTES_MAXLENGTH }}
                    disabled={!isDisable || saveDisable || !checkedInStartDate}
                    onChange={handleChange}
                    multiline
                    minRows={1}
                    maxRows={10}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
      <Grid container className="fixed-buttons-block">
        {checkPermission('update_siv_report') ? (
          <Grid md={12} display="flex" justifyContent="flex-end">
            <Stack spacing={2} direction="row">
              {isDisable ? (
                <Button
                  onClick={updateAdverseEventReportingData}
                  variant="text"
                  disabled={saveButtonDisable?.adverseEventReporting || !checkedInStartDate}
                >
                  SAVE
                </Button>
              ) : (
                ''
              )}
            </Stack>
          </Grid>
        ) : (
          ''
        )}
        <QueryMenus
          totalFieldQueries={totalFieldQueries}
          totalSectionQueries={totalSectionQueries}
          contextMenu={contextMenu}
          setContextMenu={setContextMenu}
          queryKeys={queryKeys}
          fieldQueries={fieldQueries}
          getSivReportQueries={getSivReportQueries}
          report_id={reportId}
          checkListQueries={checkListQueries}
          queryType={queryType}
          setQueryType={setQueryType}
          isSQSivQueries
        />
        <ViewQuery
          totalFieldQueries={totalFieldQueries}
          totalSectionQueries={totalSectionQueries}
          open={openViewQuery}
          setOpen={setOpenViewQuery}
          queryKeys={queryKeys}
          queryType={queryType}
          fieldQueries={fieldQueries}
          getSivReportQueries={getSivReportQueries}
          setQueryType={setQueryType}
          report_id={reportId}
          isSQSivQueries
        />
      </Grid>
    </>
  );
};

export default AdverseEventReporting;
